<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2"
        >{{ alert_msg }}
      </argon-alert>
      <div class="table-responsive p-0" v-if="userList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Nome
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Cognome
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Email
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Stato
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userList" :key="user._id">
              <table-row-user :user="user" />
              <td class="align-middle">
                <a
                  @click="this.editUser(user._id)"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Modifica"
                  href="javascript:;"
                >
                  <i class="fa fa-pen"></i
                ></a>
                <a
                  @click.stop="openModal(user._id)"
                  class="text-secondary font-weight-bold text-xs ms-2"
                  data-toggle="tooltip"
                  data-original-title="Elimina"
                  href="javascript:;"
                >
                  <i class="fa fa-trash"></i
                ></a>
                <delete-modal
                  :modalId="'deleteModal' + user._id"
                  :object="user"
                  @deleteObject="this.deleteUser"
                  @closeModal="closeModal(user._id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";
import TableRowUser from "@/views/user/tableRowUser.vue";

export default {
  name: "user-table",
  props: {
    users: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      userList: {},
    };
  },
  components: { TableRowUser, ArgonAlert, DeleteModal },
  mounted() {
    this.userList = this.users;
  },
  methods: {
    editUser(userId) {
      router.push({ name: "user-edit", params: { id: userId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push("/user-list");
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteUser(user) {
      this.$emit("deleteObject", user);
      const response = await axios.delete(
        this.$endpoint + "/user/delete/" + user._id,
        {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        this.show_success = true;
        this.alert_msg = "Utente eliminato con successo";
        const index = this.userList.findIndex((obj) => obj._id === user._id); // find the post index
        if (~index)
          // if the post exists in array
          this.userList.splice(index, 1); //delete the post
      }

      await this.closeModal(user._id);
    },
  },
};
</script>
